import { ENTER_KEY, SPACE_KEY, TEST_ID } from './constants';
import type { FunctionComponent, KeyboardEvent, Props } from './types';

import styles from './styles.module.scss';

const Tab: FunctionComponent<Props> = ({
    children,
    className = '',
    isActive,
    onClick,
    testId = TEST_ID,
    text
}) => {
    const handleKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
        if (event.key === ENTER_KEY || event.key === SPACE_KEY) {
            event.preventDefault();
            onClick?.();
        }
    };

    return (
        <span
            aria-selected={Boolean(isActive)}
            className={`${className} ${styles.tab} ${isActive ? styles.tabActive : ''}`}
            data-testid={testId}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            role="tab"
            tabIndex={0}
        >
            {children || text}
        </span>
    );
};

export default Tab;
